
import { defineComponent } from 'vue';
import { AppCard } from '@/components';
import { useQuestBoostEdit } from '@/modules/quest/boost/model/edit';
import { formatDate, renderTimeUnit } from '@/common/utils/helpers';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.BOOST.DETAIL,
    components: { AppCard },
    setup() {
        const { model } = useQuestBoostEdit();

        return { model, formatDate, renderTimeUnit };
    }
});
